import { NgModule } from '@angular/core';
// import { RouterModule} from '@angular/router';
import { SharedModule } from '@shared/shared.module';
import { DownloadDialogComponent } from '@shared/components/download-dialog/download-dialog.component';
import { DownloadService } from '@shared/components/download-dialog/download.service';
import { NgxFilesizeModule } from 'ngx-filesize';
@NgModule({
    declarations: [
        DownloadDialogComponent
    ],
    imports: [
        SharedModule,
        NgxFilesizeModule
        // RouterModule
    ],
    exports: [
        DownloadDialogComponent
    ],
    providers: [
        DownloadService,
    ]
})
export class DownloadDialogModule { }

